import React from 'react';
import moment from "moment/moment";
import {Table} from "reactstrap";
import {Form} from "react-bootstrap";
import numberFormat from "../../../helpers/numberFormat";
import {Link} from "react-router-dom";
import _  from 'lodash'
import {RacoonGroupEditRoute} from "../../routesConstants";

const OsvTable = ({tableData,start, end,cb,payment, options }) => {

  const {hideMinus,showZero,showRegisterSumm} = options
  const renderMin = (number) =>{
    const standart = {textAlign:'end'}
    return number < 0 ? {color:'red',...standart}:{...standart}
  }
  const renderHeaderRow = (row, color, cl) => {
    return <tr style={{backgroundColor:color}} className={cl}>
      <td>{row.name }</td>
      <td style={renderMin(row.totalProd)} >{numberFormat(row.totalProd)}</td>
      <td style={renderMin(row.totalStDeb)}>{numberFormat(row.totalStDeb)}</td>
      <td style={renderMin(row.totalStCr)}>{numberFormat(row.totalStCr)}</td>
      <td style={renderMin(row.totalFlowDeb)}>{numberFormat(row.totalFlowDeb)}</td>
      <td style={renderMin(row.totalFlowCr)}>{numberFormat(row.totalFlowCr)}</td>
      <td style={renderMin(row.totalEndDeb)}>{numberFormat(showRegisterSumm ? row.totalEndByRegistrs : row.totalEndDeb)}</td>
      {payment && <td style={renderMin(row.needPay)}>{numberFormat(row.needPay)}</td>}
    </tr>
  }

  const sortTable = [_.find(tableData,{first:true}),_.find(tableData,{first:false})]
  return (
    <div>

      <div className={'tableFixOnlyHead'}>
          <div id="printarea">
            <div id={'onlyPrint'} style={{display: 'none'}}>
              <h4>ОСВ за период {start.slice(0, 5)} - {end}</h4>
              <h6>СФормирован: {moment().format('DD.MM.YYYY HH:mm')}</h6>
            </div>
            <Table bordered size={'sm'}>
              <thead>
              <tr>
                <th rowSpan={2}>
                  <div className={'d-flex gap-2'}>
                    <Form.Label className={'d-flex align-items-center gap-2'} id={"notVisible"}>
                      <input
                        checked={hideMinus}
                        onChange={() => cb('hideMinus')}
                        type={"checkbox"}
                      />{" "}
                      Скрыть минусы
                    </Form.Label>
                    {!payment && <><Form.Label className={'d-flex align-items-center gap-2'} id={"notVisible"}>
                      <input
                        checked={showZero}
                        onChange={() => cb('showZero')}
                        type={"checkbox"}
                      />{" "}
                      Показать нули
                    </Form.Label>
                      <Form.Label className={'d-flex align-items-center gap-2'} id={"notVisible"}>
                        <input
                          checked={showRegisterSumm}
                          onChange={() => cb('showRegisterSumm')}
                          type={"checkbox"}
                        />{" "}
                        Сумма реестров
                      </Form.Label>
                    </>}
                  </div>

                  Контрагент
                </th>
                <th rowSpan={2}>Ком.прод</th>
                <th colSpan={2}>Сальдо нач</th>
                <th colSpan={2}>Обороты</th>
                <th>Сальдо кон</th>
                {payment &&<th rowSpan={2}>Должен</th>}
              </tr>
              <tr>
                <th>Дебет</th>
                <th>Кредит</th>
                <th>Дебет</th>
                <th>Кредит</th>
                <th>Дебет</th>
              </tr>
              </thead>
              <tbody>
              {sortTable.map((agent, index) => {
                const sorting = [_.find(agent.table, {first:true}),_.find(agent.table, {first:false})]
                return <React.Fragment key={index}>
                  {renderHeaderRow(agent, "#cfe2f3", 'blue')}
                  {sorting.map((typeFace, i) => {
                    return typeFace && <React.Fragment key={i}>
                      {renderHeaderRow(typeFace, "#d9ead3", 'green')}
                      {typeFace.table.map((row, indx) => {
                        return <tr key={indx} style={{backgroundColor: showRegisterSumm && !!row.groupId? '#f3e395' : 'white' }}>
                          <td>{row.counterparty.name}</td>
                          <td style={renderMin(row.commentProd)}>{numberFormat(row.commentProd)}</td>
                          <td style={renderMin(row.startDeb)}>{numberFormat(row.startDeb)}</td>
                          <td style={renderMin(row.startCr)}>{numberFormat(row.startCr)}</td>
                          <td style={renderMin(row.flowDeb)}>{numberFormat(row.flowDeb)}</td>
                          <td style={renderMin(row.flowCr)}>{numberFormat(row.flowCr)}</td>
                          <td style={renderMin(showRegisterSumm && row.groupId ? row.approximateSumm : row.endDeb)}>
                            <Link to={{
                              pathname: showRegisterSumm && row.groupId ? RacoonGroupEditRoute+row.groupId : "/salesRegister/create",
                              search:showRegisterSumm && row.groupId ? '' : `?start=${start}&end=${end}&id=${row.counterparty.id}`
                            }}
                                  target={'_blank'}>
                              {numberFormat(showRegisterSumm && row.groupId ? row.approximateSumm : row.endDeb)}
                            </Link>

                          </td>
                          {payment && <td style={renderMin(row.needPay)}>{numberFormat(row.flowDeb-row.flowCr)}</td>
                          }
                        </tr>
                      })}
                    </React.Fragment>
                  })}
                </React.Fragment>
              })}
              </tbody>
            </Table>
          </div>
        </div>
    </div>
  );
};

export default OsvTable;
